import { UserEvent } from './index'
import Bugsnag from '@bugsnag/js'
import { env } from '@/lib/runtimeEnv'

const sendToSegment = (event: UserEvent) => {
  // @ts-ignore
  if (!window.rudderanalytics && env.VITE_BUGSNAG_KEY) {
    Bugsnag.notify('window.rudderanalytics is not defined when tracking event')
  }

  window.rudderanalytics &&
    window.rudderanalytics.track(event.name, event.context)
}

export default sendToSegment
